import { create, v } from '@dojo/framework/core/vdom';

// import { Messages, Bundle } from '@dojo/framework/i18n/i18n';
// import { LocalizedMessages } from '@dojo/framework/core/mixins/I18n';
// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

export interface LPTextProperties {
	classes?: string[];
	name: string;
	element?: string;
	kids?: string[];
}

const factory = create().properties<LPTextProperties>();

export const LPText = factory(({ properties }) => {
	const { classes = [], name, element = 'div', kids = [''] } = properties();

	return v(element, { key: name, classes: [...classes], xqa: `lptext ${name}` }, kids);
});

export default LPText;
